import React from 'react';
import { Heading, Text } from '@atoms';
import { BlogOL, QuotationGraphic, Hyperlink } from '../../components/RichTextComponents/HeroRichText/HeroRichText.styled';
import { UnorderedList } from '@components/RichTextComponents/UnorderedList';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';

///////--COMPONENTS--///////
import { ContentfulImage } from '@components/ContentfulImage';
import { ContentfulVideo } from '@components/ContentfulVideo';
import { QuoteBlock } from '@components/RichTextComponents/QuoteBlock';

export const heroResolveRichText = ( contentObject, theme, headingStyles ) => {
  const bodyContent = JSON.parse(contentObject?.subheading?.raw);
  const references = contentObject?.body?.references;
  const renderOptions = {
    // renderText: text => text.split('\n').flatMap((text, i) => [i > 0 && <br />, text]),
    renderMark: {
      [MARKS.BOLD]: text => <Text style={{ fontWeight: 'bold', display: 'inline-block' }}>{text}</Text>,
      [MARKS.ITALIC]: text => <Text style={{ fontStyle: 'italic', display: 'inline-block'}}>{text}</Text>,
      [MARKS.UNDERLINE]: text => <Text style={{ textDecoration: 'underline', display: 'inline-block' }}>{text}</Text>,
    },
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontWeight: "900", fontSize: '50px', lineHeight: '60px' }} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontStyle: "italic", fontSize: '50px', lineHeight: '60px' }} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children?.props?.children[1]}>{children[0]?.props?.children?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', textDecoration: 'underline', fontSize: '50px', lineHeight: '60px', fontWeight: '500'}} headingSize='H1' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
                <Heading style={{ ...headingStyles, marginBottom: '20px', fontSize: '50px', lineHeight: '60px', fontWeight: '500' }} headingSize='H1' className="">     
                  <span id={children}>{children}</span>
                </Heading>
            </div>
          )}
        }
      ,
      [BLOCKS.HEADING_2]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontWeight: "900", fontSize: '38px', lineHeight: '46px' }} headingSize='H2' className="mt-2">     
                <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', fontStyle: "italic", fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="">     
                <span id={children[0]?.props?.children?.props?.children[0]}>{children[0]?.props?.children?.props?.children}</span>
              </Heading>
            </div>
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
              <Heading style={{ ...headingStyles, marginBottom: '20px', textDecoration: 'underline', fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="mt-2">     
                <span id={children[0]?.props?.children[0]}>{children[0]?.props?.children}</span>
              </Heading>
            </div>
          )
        } else {
          return (
            <div>
              <div style={{ marginTop: '80px', height: '4px', background: theme.colors.primary, borderRadius: '50px', width: '48px' }} />
                <Heading style={{ ...headingStyles, marginBottom: '20px', fontSize: '38px', lineHeight: '46px', fontWeight: '500' }} headingSize='H2' className="mt-2">     
                  <span id={children}>{children}</span>
                </Heading>
            </div>
          )}
        }
      ,
      [BLOCKS.HEADING_3]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontWeight: "900", borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontStyle: "italic", borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', textDecoration: 'underline', borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', borderLeft: '3px solid #69D1F0', paddingLeft: '30px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children}>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_4]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontWeight: "900", fontSize: '28px', lineHeight: '34px' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontStyle: "italic", fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', textDecoration: 'underline', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, color: '#002DC2', marginTop: '40px', marginBottom: '20px', fontSize: '28px', lineHeight: '34px', fontWeight: '500' }} headingSize='H3' className="mt-2">
              <span id={children}>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_5]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, fontWeight: "900", fontSize: '22px', lineHeight: '30px' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, fontStyle: "italic", fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, textDecoration: 'underline', fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, fontSize: '22px', lineHeight: '30px', fontWeight: '500' }} headingSize='H4' className="mt-2">
              <span>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.HEADING_6]: (node, children) => {
        if (children[0]?.props?.style?.fontWeight) {
          return (
            <Heading style={{ ...headingStyles, fontWeight: "900", fontSize: '20px', lineHeight: '28px' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.fontStyle) {
          return (
            <Heading style={{ ...headingStyles, fontStyle: "italic", fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else if (children[0]?.props?.style?.textDecoration) {
          return (
            <Heading style={{ ...headingStyles, textDecoration: 'underline', fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span id={children[0]?.props?.children}>{children[0]?.props?.children}</span>
            </Heading>  
          )
        } else {
          return (
            <Heading style={{ ...headingStyles, fontSize: '20px', lineHeight: '28px', fontWeight: '500' }} headingSize='H5' className="mt-2">
              <span>{children}</span>
            </Heading>  
          )}
        }
      ,
      [BLOCKS.PARAGRAPH]: (node, children) => <p style={{marginBottom: '16px'}}>{children}</p>,
      [BLOCKS.UL_LIST]: (node, children) => <UnorderedList type='checkmark' children={children}/>,
      [BLOCKS.OL_LIST]: (node, children) => <BlogOL>{children}</BlogOL>,
      [BLOCKS.QUOTE]: (node, children) => 
        <div>
          <QuotationGraphic>"</QuotationGraphic>
          <Heading style={{ color: '#002DC2' }} headingSize='H3'>{children}</Heading>
        </div>
      ,
      [BLOCKS.EMBEDDED_ENTRY]: (node, children) => {
        const id = node.data.target.sys.id;
        const component = references?.filter(subComp => subComp?.contentful_id === id);
        if (component[0]?.internal.type === 'ContentfulComponentImage') {
          return (
            <div data-comp='contentfulIMAGE' style={{ padding: '32px 0px' }}>
              <ContentfulImage imageData={component[0]} showCaption={true} />
            </div>
          )
        } else if (component[0]?.internal.type === 'ContentfulComponentVideo') {
          return (
            <div data-comp='contentfulVIDEO' style={{ padding: '32px 0px' }}>
            <ContentfulVideo videoData={component[0]}/>
          </div>
        )
        } else if (component[0]?.internal?.type?.toLowerCase().includes('quote')) {
            return (
              <div style={{ padding: '32px 0px' }}>
                <QuoteBlock quoteData={component[0]} />
              </div>
          )
        } else {
          console.log('There was an error trying to match and determine component for Blog Detail')
        }
      },
      [INLINES.HYPERLINK]: (node, children) => 
        <Hyperlink theme={theme}>{children}</Hyperlink>
    ,
    }
  };
  return documentToReactComponents(bodyContent, renderOptions);
};
